(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8111],{

/***/ 78111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BuilderDataRender; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./services/utils.js
var utils = __webpack_require__(75681);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/builder/builder.module.scss
var builder_module = __webpack_require__(20426);
var builder_module_default = /*#__PURE__*/__webpack_require__.n(builder_module);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
;// CONCATENATED MODULE: ./components/builder/helpers.ts


var builderRowStylesHandler = function(param) {
    var index = param.index, tab = param.tab, dbName = param.dbName, renderRowBackground = param.renderRowBackground, renderRowAlignItems = param.renderRowAlignItems, renderRowBgImage = param.renderRowBgImage, renderRowBgImageHeight = param.renderRowBgImageHeight;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    if ((renderRowBackground === null || renderRowBackground === void 0 ? void 0 : (ref = renderRowBackground[0]) === null || ref === void 0 ? void 0 : (ref1 = ref[tab - 1]) === null || ref1 === void 0 ? void 0 : ref1[index]) && (renderRowBackground === null || renderRowBackground === void 0 ? void 0 : (ref2 = renderRowBackground[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[tab - 1]) === null || ref3 === void 0 ? void 0 : ref3[index]) !== "transparent" && (renderRowBackground === null || renderRowBackground === void 0 ? void 0 : (ref4 = renderRowBackground[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[tab - 1]) === null || ref5 === void 0 ? void 0 : ref5[index]) !== "none") {
        var ref12, ref13, ref14, ref15;
        var ref16;
        return {
            background: renderRowBackground === null || renderRowBackground === void 0 ? void 0 : (ref12 = renderRowBackground[0]) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[tab - 1]) === null || ref13 === void 0 ? void 0 : ref13[index],
            alignItems: (ref16 = renderRowAlignItems === null || renderRowAlignItems === void 0 ? void 0 : (ref14 = renderRowAlignItems[0]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[tab - 1]) === null || ref15 === void 0 ? void 0 : ref15[index]) !== null && ref16 !== void 0 ? ref16 : "flex-start"
        };
    } else if ((renderRowBgImage === null || renderRowBgImage === void 0 ? void 0 : (ref6 = renderRowBgImage[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[tab - 1]) === null || ref7 === void 0 ? void 0 : ref7[index]) && (renderRowBgImage === null || renderRowBgImage === void 0 ? void 0 : (ref8 = renderRowBgImage[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[tab - 1]) === null || ref9 === void 0 ? void 0 : ref9[index]) !== "none") {
        var ref17, ref18, ref19, ref20, ref21, ref22;
        var ref23;
        return {
            backgroundImage: "url(".concat((0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(renderRowBgImage === null || renderRowBgImage === void 0 ? void 0 : (ref17 = renderRowBgImage[0]) === null || ref17 === void 0 ? void 0 : (ref18 = ref17[tab - 1]) === null || ref18 === void 0 ? void 0 : ref18[index])), ")"),
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            minHeight: renderRowBgImageHeight === null || renderRowBgImageHeight === void 0 ? void 0 : (ref19 = renderRowBgImageHeight[0]) === null || ref19 === void 0 ? void 0 : (ref20 = ref19[tab - 1]) === null || ref20 === void 0 ? void 0 : ref20[index],
            display: "flex",
            alignItems: (ref23 = renderRowAlignItems === null || renderRowAlignItems === void 0 ? void 0 : (ref21 = renderRowAlignItems[0]) === null || ref21 === void 0 ? void 0 : (ref22 = ref21[tab - 1]) === null || ref22 === void 0 ? void 0 : ref22[index]) !== null && ref23 !== void 0 ? ref23 : "center"
        };
    }
    var ref24;
    return {
        alignItems: (ref24 = renderRowAlignItems === null || renderRowAlignItems === void 0 ? void 0 : (ref10 = renderRowAlignItems[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[tab - 1]) === null || ref11 === void 0 ? void 0 : ref11[index]) !== null && ref24 !== void 0 ? ref24 : "flex-start"
    };
};
var builderColumnStylesHandler = function(param) {
    var index = param.index, indexCol = param.indexCol, dbName = param.dbName, tab = param.tab, renderColumn = param.renderColumn;
    var ref, ref1;
    var ref2 = (renderColumn === null || renderColumn === void 0 ? void 0 : (ref = renderColumn[tab - 1]) === null || ref === void 0 ? void 0 : (ref1 = ref[index]) === null || ref1 === void 0 ? void 0 : ref1[indexCol]) || {}, columnCol = ref2.backgroundColor, columnImg = ref2.backgroundImage, columnHeight = ref2.bgImageHeight, columnAlignment = ref2.alignItems;
    if (columnCol && columnCol !== "transparent" && columnCol !== "none") {
        return {
            background: columnCol
        };
    } else if (columnImg && columnImg !== "none") {
        var alignItems = {};
        if (columnAlignment && columnAlignment.length > 0) {
            alignItems = {
                display: "flex",
                alignItems: columnAlignment
            };
        }
        return (0,_object_spread/* default */.Z)({
            backgroundImage: "url(".concat((0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(columnImg)), ")"),
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            minHeight: columnHeight
        }, alignItems);
    }
    return {};
};

;// CONCATENATED MODULE: ./components/builder/BuilderDataRender.tsx







/*** made dynamic imports for builder components ***/ var Heading = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4817).then(__webpack_require__.bind(__webpack_require__, 24817));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24817)
            ];
        }
    }
});
var HyperLink = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2723).then(__webpack_require__.bind(__webpack_require__, 52723));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52723)
            ];
        }
    }
});
var Editor = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7677).then(__webpack_require__.bind(__webpack_require__, 27677));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27677)
            ];
        }
    }
});
var AccordionComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7357).then(__webpack_require__.bind(__webpack_require__, 97357));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97357)
            ];
        }
    }
});
var ImageUploadingApp = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(8028)]).then(__webpack_require__.bind(__webpack_require__, 28028));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28028)
            ];
        }
    }
});
var Button = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2149).then(__webpack_require__.bind(__webpack_require__, 2149));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2149)
            ];
        }
    }
});
var VideoComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3948).then(__webpack_require__.bind(__webpack_require__, 33948));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33948)
            ];
        }
    }
});
var BlogsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(4432), __webpack_require__.e(3997), __webpack_require__.e(9790)]).then(__webpack_require__.bind(__webpack_require__, 49790));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49790)
            ];
        }
    }
});
var RenderBuilderComponent = function(param) {
    var data = param.data, domain = param.domain, dbName = param.dbName;
    var builderComponents = {
        Heading: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
            item: data
        }),
        HyperLink: /*#__PURE__*/ (0,jsx_runtime.jsx)(HyperLink, {
            item: data
        }),
        Editor: /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor, {
            item: data
        }),
        Accordion: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionComponent, {
            item: data
        }),
        ImageUpload: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageUploadingApp, {
            item: data,
            dbName: dbName
        }),
        Button: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
            item: data
        }),
        Video: (data === null || data === void 0 ? void 0 : data.fullScreen) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "video_wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoComponent, {
                item: data
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoComponent, {
            item: data
        }),
        Blogs: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogsComponent, {
            domain: domain,
            item: data
        }),
        Grid: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    };
    return builderComponents[data === null || data === void 0 ? void 0 : data.content] || /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
var BuilderSection = function(param) {
    var tree = param.tree, tab = param.tab, componentsData = param.componentsData, initialLayout = param.initialLayout, domain = param.domain, dbName = param.dbName;
    var ref;
    var renderClass = (0,utils/* renderMapData */.Lq)(initialLayout, "class");
    var renderRowBackground = (0,utils/* renderMapData */.Lq)(initialLayout, "backgroundColor");
    var renderRowBgImage = (0,utils/* renderMapData */.Lq)(initialLayout, "backgroundImage");
    var renderRowBgImageHeight = (0,utils/* renderMapData */.Lq)(initialLayout, "bgImageHeight");
    var renderBlockAlignItems = (0,utils/* renderMapData */.Lq)(initialLayout, "alignItems");
    var renderRowAlignItems = (0,utils/* renderMapData */.Lq)(initialLayout, "alignItemsRow");
    var renderRowFullScreen = (0,utils/* renderMapData */.Lq)(initialLayout, "fullScreen");
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,utils/* renderMapData */.Lq)(initialLayout, "column") || [], 1), tmp = ref1[0], renderColumn = tmp === void 0 ? [] : tmp;
    var rowStyles = function(index) {
        return builderRowStylesHandler({
            index: index,
            tab: tab,
            dbName: dbName,
            renderRowBgImage: renderRowBgImage,
            renderRowBackground: renderRowBackground,
            renderRowBgImageHeight: renderRowBgImageHeight,
            renderRowAlignItems: renderRowAlignItems
        });
    };
    var columnStyles = function(index, indexCol) {
        return builderColumnStylesHandler({
            index: index,
            indexCol: indexCol,
            tab: tab,
            dbName: dbName,
            renderColumn: renderColumn
        });
    };
    return componentsData && Object.values(componentsData).length > 0 && tree[tab] && Object.values(tree[tab]).length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "block-products",
        style: {
            marginBottom: 0
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((builder_module_default())["home-product-container"], " ").concat((builder_module_default())["b-container"]),
            children: tree && tab && Array.isArray(tree === null || tree === void 0 ? void 0 : tree[tab]) && ((ref = tree[tab]) === null || ref === void 0 ? void 0 : ref.map(function(item, ind) {
                var ref;
                if ((item === null || item === void 0 ? void 0 : item.length) === 1 && (item === null || item === void 0 ? void 0 : (ref = item[0]) === null || ref === void 0 ? void 0 : ref.length) === 1) {
                    var ref1, ref2;
                    var BuilderComponent = (0,utils/* createBuilderData */.p7)(componentsData, item[0][0]);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "zg-grid-col zg-col-lg zg-col-sm zg-col-md ".concat(!(renderRowFullScreen === null || renderRowFullScreen === void 0 ? void 0 : (ref1 = renderRowFullScreen[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[tab - 1]) === null || ref2 === void 0 ? void 0 : ref2[ind]) && "container", " ").concat((builder_module_default()).builder_component),
                        // style={rowStyles(ind)}
                        style: {
                            flex: "1, 0"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderBuilderComponent, {
                            domain: domain,
                            data: BuilderComponent,
                            dbName: dbName
                        })
                    }, (0,utils/* idGen */["do"])());
                } else {
                    var ref3, ref4;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "zg-row ".concat(!(renderRowFullScreen === null || renderRowFullScreen === void 0 ? void 0 : (ref3 = renderRowFullScreen[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[tab - 1]) === null || ref4 === void 0 ? void 0 : ref4[ind]) && "container", " ").concat((builder_module_default()).builder_component),
                        style: rowStyles(ind),
                        children: item === null || item === void 0 ? void 0 : item.map(function(element, index) {
                            if ((element === null || element === void 0 ? void 0 : element.length) === 1) {
                                var ref, ref1, ref2;
                                var BuilderComponent = (0,utils/* createBuilderData */.p7)(componentsData, element[0]);
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(renderClass === null || renderClass === void 0 ? void 0 : (ref = renderClass[0]) === null || ref === void 0 ? void 0 : (ref1 = ref[tab - 1]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[ind]) === null || ref2 === void 0 ? void 0 : ref2[index], " ").concat((builder_module_default()).builder_component),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderBuilderComponent, {
                                        domain: domain,
                                        data: BuilderComponent,
                                        dbName: dbName
                                    })
                                }, (0,utils/* idGen */["do"])());
                            } else {
                                var ref3, ref4, ref5;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: renderClass === null || renderClass === void 0 ? void 0 : (ref3 = renderClass[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[tab - 1]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[ind]) === null || ref5 === void 0 ? void 0 : ref5[index],
                                    style: columnStyles(ind, index),
                                    children: element === null || element === void 0 ? void 0 : element.map(function(elInEl) {
                                        var BuilderComponent = (0,utils/* createBuilderData */.p7)(componentsData, elInEl);
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (builder_module_default()).builder_component,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderBuilderComponent, {
                                                domain: domain,
                                                data: BuilderComponent,
                                                dbName: dbName
                                            })
                                        }, (0,utils/* idGen */["do"])());
                                    })
                                }, (0,utils/* idGen */["do"])());
                            }
                        })
                    }, (0,utils/* idGen */["do"])());
                }
            }))
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var BuilderDataRender = (/*#__PURE__*/(0,react.memo)(BuilderSection));


/***/ }),

/***/ 20426:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card-faq":"builder_card-faq___8Hjc","rc-accordion-card":"builder_rc-accordion-card__SoU6T","rc-accordion-toggle":"builder_rc-accordion-toggle__l_bh4","active":"builder_active__z0l8Z","rc-accordion-icon":"builder_rc-accordion-icon__5UnOD","rc-accordion-title":"builder_rc-accordion-title__HMLEs","rc-collapse":"builder_rc-collapse__5BWI3","show":"builder_show__JxzY2","rc-accordion-body":"builder_rc-accordion-body__G4F_R","b-container":"builder_b-container__iumtw","zg-grid-col":"builder_zg-grid-col__HDyvd","zg-row":"builder_zg-row__hLWu7","zg-dragforborder":"builder_zg-dragforborder__akYEv","builder_component":"builder_builder_component__f722A","zg-col-lg":"builder_zg-col-lg__H9V0R","zg-col-md":"builder_zg-col-md__vIYqG","zg-col-sm":"builder_zg-col-sm__lV4MC"};

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ })

}]);